import { z } from 'zod';

const skagBoolean = z.union([z.literal(true), z.literal('true'), z.literal(false), z.literal('false')]);

export const schemaGetTokenSuccessResponse = z.object({
    access_token: z.string(),
    error: z.array(z.unknown()).optional(),
    expires_in: z.number(),
    mode: z.string().optional(),
    success: z.union([z.literal(true), z.literal('true')]),
    type: z.string().optional(),
});

export const schemaGetTokenFailureResponse = z.object({
    code: z.string().optional(),
    errors: z.union([z.string(), z.array(z.string())]).optional(),
    success: z.union([z.literal(false), z.literal('false')]),
});

export const schemaGetTokenResponse = z.union([schemaGetTokenSuccessResponse, schemaGetTokenFailureResponse]);

export type SchemaGetTokenResponse = z.infer<typeof schemaGetTokenResponse>;

export const isGetTokenSuccess = (
    response: SchemaGetTokenResponse,
): response is z.infer<typeof schemaGetTokenSuccessResponse> =>
    response.success === true || response.success === 'true';

export { skagBoolean };
